import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Theme, Typography } from '@material-ui/core';
import Content from 'containers/common/sections/privacy/Content';
import { PageLink } from 'components/common/atoms';
import useI18n from "evcharging/hooks/useI18n";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: 140,
  },
  rootName: {
    fontWeight: 600,
    fontSize: 24,
    color: theme.palette.primary.main,
    lineHeight: 1.5,
    paddingRight: theme.spacing(1),
  },
}));

const Term: FC = () => {
  const { t } = useI18n();

  const styles = useStyles();

  return (
    <>
      <Grid className={styles.root} container>
        <Grid item>
          <Typography className={styles.rootName}>
            <PageLink href={'/'} rel="noreferrer">
              {t('nav.home')} /
            </PageLink>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h1" className={styles.rootName}>
            {t('nav.terms-conditions')}
          </Typography>
        </Grid>
      </Grid>
      <Content
        listItems={[
          t('terms.text1'),
          t('terms.text2'),
          t('terms.text3'),
        ]}
      />
      <Content
        title={t('terms.cookies')}
        listItems={[
          t('terms.cookies.text1'),
          t('terms.cookies.text2'),
        ]}
      />
      <Content
        title={t('terms.license')}
        listItems={[
          t('terms.license.text1'),
          t('terms.license.text2'),
          t('terms.license.text3'),
          t('terms.license.text4'),
          t('terms.license.text5'),
          t('terms.license.text6'),
          t('terms.license.text7'),
        ]}
      />

      <Content
        title={t('terms.hyperlinking')}
        listItems={Array.from({ length: 22 }, (_, i) => t(`terms.hyperlinking.text${i + 1}`))}
      />

      <Content title={t('terms.iframes')} listItems={[t('terms.iframe.text')]} />

      <Content title={t('terms.liability')} listItems={[t('terms.liability.text')]} />

      <Content title={t('terms.privacy')} listItems={[t('terms.privacy.text')]} />

      <Content title={t('terms.reservation')} listItems={[t('terms.reservation.text')]} />

      <Content title={t('terms.removal')} listItems={[t('terms.removal.text1'), t('terms.removal.text2')]} />

      <Content
        title={t('terms.disclaimer')}
        listItems={[
          t('terms.disclaimer.text1'),
          t('terms.disclaimer.text2'),
          t('terms.disclaimer.text3'),
          t('terms.disclaimer.text4'),
          t('terms.disclaimer.text5'),
          t('terms.disclaimer.text6'),
          t('terms.disclaimer.text7'),
        ]}
      />
    </>
  );
};

export default Term;
